export default "__VITE_ASSET__BD4xdl9N__"